import {
  NOTIFICATION_EVENT_TYPE,
  NotificationItem,
} from "api/interfaces/notificationInterface.interface";
import { getAccountTimeFormat } from "./timeUtil";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { StompMessageKind } from "redux/stomp/interface";

import { ReactComponent as RecorderAdded } from "assets/icons/notification/recorder_added.svg";
import { ReactComponent as RecorderRemoved } from "assets/icons/notification/recorder_removed.svg";
import { ReactComponent as Recorder } from "assets/icons/notification/recorder.svg";
import { ReactComponent as RecorderWarn } from "assets/icons/notification/recorder_warn.svg";
import { ReactComponent as UserAdded } from "assets/icons/notification/user_added.svg";
import { ReactComponent as UserRemoved } from "assets/icons/notification/user_removed.svg";
import { ReactComponent as OrgAdded } from "assets/icons/notification/org_added.svg";
import { ReactComponent as OrgRemoved } from "assets/icons/notification/org_removed.svg";
import { ReactComponent as OrgUpdated } from "assets/icons/notification/org_updated.svg";
import { ReactComponent as VideoAdded } from "assets/icons/notification/video_added.svg";
import { ReactComponent as VideoRemoved } from "assets/icons/notification/video_removed.svg";
import { ReactComponent as ReportAdded } from "assets/icons/notification/report_added.svg";
import { ReactComponent as ReportRemoved } from "assets/icons/notification/report_removed.svg";
import { ReactComponent as AssignAdded } from "assets/icons/notification/alert_assigned.svg";
import { ReactComponent as AssignRemoved } from "assets/icons/notification/alert_removed.svg";
import { ReactComponent as CommentAdded } from "assets/icons/notification/alert_added.svg";
import { ReactComponent as CameraAdded } from "assets/icons/notification/camera_added.svg";
import { ReactComponent as CameraRemoved } from "assets/icons/notification/camera_removed.svg";
import { ReactComponent as Camera } from "assets/icons/notification/camera.svg";
import { ReactComponent as SubscriptionAdded } from "assets/icons/notification/license_added.svg";
import { ReactComponent as SubscriptionRemoved } from "assets/icons/notification/license_removed.svg";
import { ReactComponent as SubscriptionKeyActivated } from "assets/icons/notification/key_activated.svg";
import { ReactComponent as SubscriptionKeyRequested } from "assets/icons/notification/key_requested.svg";
import { ReactComponent as SubscriptionKeyConfirmed } from "assets/icons/notification/key_confirmed.svg";
import { ReactComponent as AlertRuleAdded } from "assets/icons/notification/alert_rule_added.svg";
import { ReactComponent as AlertRuleRemoved } from "assets/icons/notification/alert_rule_removed.svg";
import { ReactComponent as AlertRuleUpdated } from "assets/icons/notification/alert_rule_updated.svg";
import { ReactComponent as UserInvited } from "assets/icons/notification/user_signup.svg";
import {
  PLAN_KEY_TYPE,
  SUBSCRIPTION_WS_STATUS,
} from "redux/stomp/stompSubscriptionSlice";
import { formatUppercaseOnly } from "./functions";
import FirmwareIcon from "assets/icons/notification/FirmwareIcon";
import { IoCardOutline } from "react-icons/io5";
//알림타입별 타이틀 변환
export const convertKindToText = ({
  kind,
  eventType,
  subKind,
}: NotificationItem) => {
  switch (kind) {
    case StompMessageKind.FIRMWARE:
      return "Firmware Update Available";
    case StompMessageKind.ASSIGN:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Alert Assigned";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Alert Closed";
      }
      return "Alert Info";
    case StompMessageKind.COMMENT:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Comment Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Comment Removed";
      }
      return "Comment Info";
    case StompMessageKind.RECORDER:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Recorder Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Recorder Removed";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.WARN) {
        return "Missing Address";
      }
      return "Recorder Info";
    case StompMessageKind.RECORDER_GROUP:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Recorder Group Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Recorder Group Removed";
      }
      return "Recorder Group Info";
    case StompMessageKind.ALERT_RULE:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Alert Rule Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Alert Rule Removed";
      }
      return "Alert Rule Updated";
    case StompMessageKind.SUBSCRIPTION: {
      if (eventType === NOTIFICATION_EVENT_TYPE.UPDATE && subKind) {
        return `Subscription ${formatUppercaseOnly(subKind)}`;
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Subscription Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Subscription Removed";
      }
      return "Subscription Info";
    }
    case StompMessageKind.USER: {
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "User Invited";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.SIGNUP) {
        return "A User Has Joined your Org";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "User Removed";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.REQUEST) {
        return "User Access is Requested";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.ACCESS) {
        return "User Access is Confirmed";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.EXPIRED) {
        return "User Access is Ended";
      }
      return "User Info";
    }
    case StompMessageKind.USER_GROUP:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "User Group Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "User Group Removed";
      }
      return "User Group Info";
    case StompMessageKind.ORGANIZATION: {
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Organization Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.UPDATE) {
        return "Organization Updated";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Organization Removed";
      }
      return "Organization Info";
    }
    case StompMessageKind.VIDEO_SHARE:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Video Share Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Video Share Removed";
      }
      return "Video Share Info";
    case StompMessageKind.REPORT:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Report Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Report Removed";
      }
      return "Report Info";
    case StompMessageKind.CAMERA:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return "Camera Added";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return "Camera Removed";
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.UPDATE) {
        return "Camera Updated";
      }
      return "Camera Info";
    // case StompMessageKind.ALERT:
    //   return eventType === NOTIFICATION_EVENT_TYPE.ADD
    //     ? "Alert Added"
    //     : "Alert Removed";
    case StompMessageKind.PLAN:
      if (
        (eventType === NOTIFICATION_EVENT_TYPE.ADD ||
          eventType === NOTIFICATION_EVENT_TYPE.DELETE) &&
        subKind === "autoEnroll"
      ) {
        return "Usage Updated";
      }

      if (
        eventType === NOTIFICATION_EVENT_TYPE.UPDATE &&
        subKind === "period"
      ) {
        return "Usage Period is Updated";
      }
      return "Usage Info";
    default:
      return "";
  }
};

//알림타입별 아이콘 변환
export const convertKindToIcon = ({
  kind,
  eventType,
  subKind,
}: NotificationItem) => {
  switch (kind) {
    case StompMessageKind.FIRMWARE:
      return <FirmwareIcon />;
    case StompMessageKind.ASSIGN:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <AssignAdded />;
      }
      return <AssignRemoved />;
    case StompMessageKind.ALERT_RULE:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <AlertRuleAdded />;
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return <AlertRuleRemoved />;
      }
      return <AlertRuleUpdated />;
    case StompMessageKind.COMMENT:
      return <CommentAdded />;
    case StompMessageKind.RECORDER:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <RecorderAdded />;
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.INFO) {
        return <Recorder />;
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.WARN) {
        return <RecorderWarn />;
      }
      return <RecorderRemoved />;
    case StompMessageKind.RECORDER_GROUP:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <RecorderAdded />;
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.INFO) {
        return <Recorder />;
      }
      return <RecorderRemoved />;
    case StompMessageKind.USER:
      if (
        eventType === NOTIFICATION_EVENT_TYPE.ADD ||
        eventType === NOTIFICATION_EVENT_TYPE.ACCESS
      ) {
        return <UserInvited />;
      }
      if (
        eventType === NOTIFICATION_EVENT_TYPE.SIGNUP ||
        eventType === NOTIFICATION_EVENT_TYPE.REQUEST
      ) {
        return <UserAdded />;
      }
      return <UserRemoved />;
    case StompMessageKind.SUBSCRIPTION: {
      switch (subKind) {
        case SUBSCRIPTION_WS_STATUS.REQUESTED:
          return <SubscriptionKeyRequested />;
        case SUBSCRIPTION_WS_STATUS.ACTIVATED:
          return <SubscriptionKeyActivated />;
        case SUBSCRIPTION_WS_STATUS.CONFIRMED:
          return <SubscriptionKeyConfirmed />;
        default:
          return <SubscriptionKeyActivated />;
      }
    }
    case StompMessageKind.USER_GROUP:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <UserAdded />;
      }
      return <UserRemoved />;
    case StompMessageKind.ORGANIZATION:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <OrgAdded />;
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.UPDATE) {
        return <OrgUpdated />;
      }
      return <OrgRemoved />;
    case StompMessageKind.VIDEO_SHARE:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <VideoAdded />;
      }
      return <VideoRemoved />;
    case StompMessageKind.REPORT:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <ReportAdded />;
      }
      return <ReportRemoved />;
    case StompMessageKind.CAMERA:
      if (eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return <CameraAdded />;
      }
      if (eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        return <CameraRemoved />;
      }
      return <Camera />;
    // case StompMessageKind.ALERT:
    //   return eventType === NOTIFICATION_EVENT_TYPE.ADD ? (
    //     <AlertAdded />
    //   ) : (
    //     <AlertRemoved />
    //   );
    case StompMessageKind.PLAN:
      return <IoCardOutline size={25} />;

    default:
      return null;
  }
};

export const convertTime = (
  time: number,
  selectAccount: ProfileAccountInfo
) => {
  return getAccountTimeFormat(
    new Date(time).toISOString(),
    selectAccount,
    true
  );
};

export const convertMsg = (item: NotificationItem): JSX.Element => {
  switch (item.kind) {
    case StompMessageKind.FIRMWARE:
      return (
        <>
          A new update for <b>{item.subKind}</b> is available. You can update it
          remotely through myDW.
        </>
      );
    case StompMessageKind.ASSIGN:
      let assignMessage: JSX.Element | string = "closed";
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        assignMessage = (
          <>
            assigned to <b>{item.targetEmail}</b>
          </>
        );
      }

      return (
        <>
          The recorder <b>{item.kindName}</b> in <b>{item.accountName}</b>{" "}
          {assignMessage}
        </>
      );
    case StompMessageKind.ALERT_RULE:
      let article = "An ";
      let alertRuleAction = "updated in";

      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        article = "A new ";
        alertRuleAction = "added to";
      } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        alertRuleAction = "removed from";
      }

      return (
        <>
          {article}Alert Rule titled <b>{item.kindName}</b> has been{" "}
          {alertRuleAction} <b>{item.accountName}</b>.
        </>
      );
    case StompMessageKind.COMMENT:
      if (item.opName) {
        let commentOperatorAction = "updated";
        if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
          commentOperatorAction = "added";
        } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
          commentOperatorAction = "removed";
        }

        return (
          <>
            <b>{item.opName}</b> has {commentOperatorAction} a comment to the
            recorder alert for <b>{item.kindName}</b> in{" "}
            <b>{item.accountName}</b>.
          </>
        );
      }
      let commentAction = "updated in";
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        commentAction = "added to";
      } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        commentAction = "removed from";
      }

      return (
        <>
          A comment has been {commentAction} the recorder alert for{" "}
          <b>{item.kindName}</b> in <b>{item.accountName}</b>.
        </>
      );
    case StompMessageKind.SUBSCRIPTION: {
      if (item.eventType === NOTIFICATION_EVENT_TYPE.UPDATE) {
        switch (item.subKind) {
          case SUBSCRIPTION_WS_STATUS.REQUESTED:
            return (
              <>
                <b>{item.accountName}</b> has requested a Subscription Key.
              </>
            );
          case SUBSCRIPTION_WS_STATUS.ACTIVATED:
            return (
              <>
                <b>{item.accountName}</b> has activated a Subscription Key.
              </>
            );
          case SUBSCRIPTION_WS_STATUS.CONFIRMED:
            return (
              <>
                The Subscription Key request for <b>{item.accountName}</b> has
                been confirmed.
              </>
            );
        }
      }
      return (
        <>
          <b>{item.accountName}</b> has requested a subscription.
        </>
      );
    }
    case StompMessageKind.CAMERA:
      if (
        item.eventType === NOTIFICATION_EVENT_TYPE.ADD ||
        item.eventType === NOTIFICATION_EVENT_TYPE.DELETE ||
        item.eventType === NOTIFICATION_EVENT_TYPE.UPDATE
      ) {
        const firstCamera = item.camera?.[0];
        const cameraCount = (item.camera || []).length;
        let cameraCountLabel = "";
        if (cameraCount > 1) {
          cameraCountLabel = ` and ${cameraCount - 1} additional cameras`;
        }

        let cameraVerb = "have been ";
        if (cameraCount === 1) {
          cameraVerb = "has been ";
        }

        let cameraAction = "updated in";

        if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
          cameraAction = "added to";
        } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
          cameraAction = "removed from";
        }

        return (
          <>
            {item.camera && firstCamera && (
              <b>
                {firstCamera.name}
                {firstCamera.channel > -1 && ` #${firstCamera.channel + 1}`}
                {cameraCountLabel}
              </b>
            )}{" "}
            {cameraVerb}
            {cameraAction} <b>{item.kindName}</b> in <b>{item.accountName}</b>
          </>
        );
      } else {
        return (
          <>
            {item.message} (<b>{item.kindName}</b> of <b>{item.accountName}</b>)
          </>
        );
      }
    case StompMessageKind.RECORDER:
      if (item.eventType === NOTIFICATION_EVENT_TYPE.INFO) {
        return (
          <>
            {item.message} (<b>{item.kindName}</b> of <b>{item.accountName}</b>)
          </>
        );
      }
      if (item.eventType === NOTIFICATION_EVENT_TYPE.WARN) {
        return (
          <>
            The address of <b>{item.kindName}</b> in <b>{item.accountName}</b>{" "}
            is missing or incorrect. Please enter the address again.
          </>
        );
      }
      let recorderAction = "updated in";
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        recorderAction = "added to";
      } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        recorderAction = "removed from";
      }

      return (
        <>
          <b>[{item.subKind}]</b> <b>{item.kindName}</b> has been{" "}
          {recorderAction} <b>{item.accountName}</b>
        </>
      );

    case StompMessageKind.RECORDER_GROUP:
      if (
        item.eventType === NOTIFICATION_EVENT_TYPE.INFO ||
        item.eventType === NOTIFICATION_EVENT_TYPE.WARN
      ) {
        return <>{item?.message}</>;
      } else {
        let recorderGroupAction = "updated in";
        if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
          recorderGroupAction = "added to";
        } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
          recorderGroupAction = "removed from";
        }

        return (
          <>
            <b>{item.kindName}</b> has been {recorderGroupAction}{" "}
            <b>{item.accountName}</b>
          </>
        );
      }
    case StompMessageKind.USER:
      if (item.message) {
        return <>{item.message}</>;
      }
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        return (
          <>
            <b>{item.kindName}</b> has been invited to the{" "}
            <b>{item.accountName}</b> organization.
          </>
        );
      }
      if (item.eventType === NOTIFICATION_EVENT_TYPE.SIGNUP) {
        return (
          <>
            <b>{item.kindName}</b> has joined your organization:{" "}
            <b>{item.accountName}</b>
          </>
        );
      }

      if (item.eventType === NOTIFICATION_EVENT_TYPE.REQUEST) {
        return (
          <>
            <b>{item.kindName}</b> has requested temporary access:{" "}
            <b>{item.accountName}</b>
          </>
        );
      }
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ACCESS) {
        return (
          <>
            <b>{item.kindName}</b>'s temporary access approved:{" "}
            <b>{item.accountName}</b>
          </>
        );
      }
      if (item.eventType === NOTIFICATION_EVENT_TYPE.EXPIRED) {
        return (
          <>
            <b>{item.kindName}</b>'s temporary access has ended:{" "}
            <b>{item.accountName}</b>
          </>
        );
      }
      return (
        <>
          <b>{item.kindName}</b> has withdrawn from <b>{item.accountName}</b>
        </>
      );
    case StompMessageKind.USER_GROUP:
      let userGroupAction = "updated in";
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        userGroupAction = "added to";
      } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        userGroupAction = "removed from";
      }

      return (
        <>
          <b>{item.kindName}</b> {userGroupAction} <b>{item.accountName}</b>
        </>
      );
    case StompMessageKind.ORGANIZATION:
      let organizationAction = "removed";
      let organizationOperator: JSX.Element | null = null;

      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        organizationAction = "added";
      } else if (item.eventType === NOTIFICATION_EVENT_TYPE.UPDATE) {
        organizationAction = "updated";
      }

      if (item.opName) {
        organizationOperator = (
          <>
            by <b>{item.opName}</b>
          </>
        );
      } else if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        organizationOperator = <>by {item.accountName}</>;
      }

      return (
        <>
          <b>{item.kindName}</b> has been {organizationAction}{" "}
          {organizationOperator}
        </>
      );
    case StompMessageKind.VIDEO_SHARE:
      let videoShareAction = "updated in";
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        videoShareAction = "added to";
      } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        videoShareAction = "removed from";
      }

      return (
        <>
          <b>{item.kindName}</b> has been {videoShareAction}{" "}
          <b>{item.accountName}</b>'s Video Share.
        </>
      );
    case StompMessageKind.REPORT:
      let reportArticle = "A ";
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        reportArticle = "A new ";
      } else if (
        ((item.subKind || "").at(0) || "").toUpperCase().includes("I")
      ) {
        reportArticle = "An ";
      }

      let reportKindLabel: JSX.Element | string = item.subKind || "";
      if (item.subKind !== "CP" && item.subKind !== "CVV") {
        reportKindLabel = (
          <>
            {(item.subKind || "").at(0)}
            {(item.subKind || "").toLowerCase().substring(1)}
          </>
        );
      }

      let reportAction = "updated in";
      if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
        reportAction = "added to";
      } else if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
        reportAction = "removed from";
      }

      return (
        <>
          {reportArticle}
          <b>{reportKindLabel}</b> report titled <b>{item.kindName}</b> has been{" "}
          {reportAction} <b>{item.accountName}</b>.
        </>
      );
    // case StompMessageKind.ALERT:
    //   return eventType === NOTIFICATION_EVENT_TYPE.ADD ? (
    //     <AlertAdded />
    //   ) : (
    //     <AlertRemoved />
    //   );
    case StompMessageKind.PLAN:
      switch (item.subKind) {
        case PLAN_KEY_TYPE.AUTO_ENROLL:
          let action = "has updated a usage plan.";
          if (item.eventType === NOTIFICATION_EVENT_TYPE.ADD) {
            action = "has switched to usage plan.";
          }
          if (item.eventType === NOTIFICATION_EVENT_TYPE.DELETE) {
            action = "has removed from usage plan.";
          }
          return (
            <>
              <b>{item.kindName}</b> {action}
            </>
          );
        case PLAN_KEY_TYPE.PERIOD:
          return (
            <>
              <b>{item.accountName}</b> has updated a usage period.
            </>
          );
        default:
          return (
            <>
              <b>{item.accountName}</b> has updated a usage plan.
            </>
          );
      }

    default:
      return <></>;
  }
};
